import { HStack, responsive } from "goi_common";
import { PropsWithChildren } from "react";

import { MOBILE_WIDTH } from "@/constants/layout";

export const FixedCustomButton = (props: PropsWithChildren<object>) => {
  const { children } = props;

  return (
    <HStack
      css={responsive({
        position: "fixed",
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        width: "100%",
        maxWidth: `${MOBILE_WIDTH}px`,
        padding: "12px 20px",
      })}
    >
      {children}
    </HStack>
  );
};
